// feed-wizard.base.ts
export abstract class FeedWizard {
  protected options: Record<string, any> = {};
  protected feedService?: { addFeed: (feed: any) => void };

  abstract getPluginSteps(): { name: string; template?: string }[];
  abstract createFeed(name: string, defaultFeedOptions: any, customFeedOptions: any): void;

  setOption(option: string, value: any): void {
    this.options[option] = value;
  }

  getOption(option: string): any {
    return this.options[option];
  }

  getOptions(): Record<string, any> {
    return this.options;
  }

  setFeedService(feedService: { addFeed: (feed: any) => void }) {
    this.feedService = feedService;
  }

  addToFeedService(feed: any): void {
    if (!this.feedService) throw new Error('feedService not set');
    this.feedService.addFeed(feed);
  }
}

interface FeedWizardWithService extends FeedWizard {
  setFeedService(feedService: { addFeed: (feed: any) => void }): void;
}